module.exports = __webpack_public_path__ + "img/Banerjee.49106dfb.jpg";